<ul class="tabs-group" [class.tabs-addition]="addRemoveButtons" #tabsGroup [ngClass]="{'disabled':disableTabChange, 'not-vertical':!vertical}" >
	<li class="tab-title" *ngFor="let tab of tabs; index as i" (click)="selectTab(tab)" [ngClass]="{ active: tab.active,'has-changes':tab.hasChanges, disabled: tab.disabled, invalid:tab.invalid }">
		<span class="tab-title-content" #tabTitle [style.width.px]="tabTitleWidth" [style.text-align]="tabTitleAlignment">
			<span  *ngIf="!tab.dontShowBaseTemplate">
				<i *ngIf="tab.iconClass" [class]="tab.iconClass"></i>
				<span class="tab-title-text" >{{tab.tabTitle}}</span>
			</span>

			<ng-template class="tab-title-template"
							[ngTemplateOutlet]="titleTplDirective"
							[ngTemplateOutletContext]="{index:i,
													tabTitle: tab.tabTitle,
													extraData:tab.extraData,
													iconClass: tab.iconClass,
													tabTitleRef: tabTitle}">
			</ng-template>
		</span>
	</li>
</ul>
<div *ngIf="addRemoveButtons" class="add-remove-buttons tabs-group">
	<ul class="tabs-group">
		<li class="add-remove-wrapper">
			<div class="tab-action cp-icon-color-1">
				<i class="cp-icon-procedure_add"  (click)="addNew.emit()"></i>
			</div>
		</li>

		<li class="add-remove-wrapper">
			<div class="tab-action cp-icon-color-1" [class.disabled]="tabs.length===0 || findActive()==null">
				<i class="cp-icon-delete" (click)="removeActive();"></i>
			</div>
		</li>
	</ul>
</div>
<ng-content></ng-content>
